import { gql } from "@apollo/client";

//QUERY_DAILY_BUBBLE_FINISHED_PAGE
export const QUERY_HOME_FINISHED_PAGE = gql`
  query homeFinished {
    homeFinishedPage {
      data {
        attributes {
          messageSection {
            youAreDoneTitle
            comeBackTitle
          }
          continueYourWeelbeingJourneyTitle
          knowledgeBasesTitle
          knowledgeBasesDescription
          toolkitsTitle
          toolkitsDescription
        }
      }
    }
  }
`;
